<script lang="ts" setup>
import { $fetch } from '@/home/plugins/fetch';
import InfoCard from '@/home/components/InfoCard.vue';
import NumberCard from './NumberCard.vue';
import { useAsyncData } from '@/home/hooks/async-data';

const { data: listing } = useAsyncData('about:cloudCommunity', () => $fetch('/committee/member/v1/list', { data: { committeeType: 5 } }))
</script>

<template>
  <section class="page-about-cloud-community pt-48px">
    <div class="about-cloud-community-container container pb-48px">
      <h2 class="m-0 text-center text-32px font-medium <md:text-24px">{{ $t('about.cloudCommunity.title') }}</h2>

      <InfoCard class="structure-box mt-32px" title-class="min-w-178" :title="$t('about.cloudCommunity.title')">
        <p class="m-0 text-16px leading-24px">{{ $t('about.cloudCommunity.description') }}</p>
        <ul class="mx-0 mb-0 mt-16px flex flex-wrap list-none gap-y-32 p-0">
          <li class="w-25% <md:w-full">
            <NumberCard number="1">{{ $t('about.cloudCommunity.duty1') }}</NumberCard>
          </li>
          <li class="w-25% <md:w-full">
            <NumberCard number="2">{{ $t('about.cloudCommunity.duty2') }}</NumberCard>
          </li>
          <li class="w-25% <md:w-full">
            <NumberCard number="3">{{ $t('about.cloudCommunity.duty3') }}</NumberCard>
          </li>
          <li class="w-25% <md:w-full">
            <NumberCard number="4">{{ $t('about.cloudCommunity.duty4') }}</NumberCard>
          </li>
        </ul>
      </InfoCard>

      <ul class="contributors m-0 flex flex-shrink flex-wrap list-none p-0">
        <li v-for="item in listing" :key="item.id">
          <img class="lazyload" :data-src="item.photo" :alt="item.name" :title="item.name">
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-about-cloud-community {
  .contributors {
    margin-top: 48px;

    li {
      width: 213px;
      height: 78px;
      margin-left: 16px;
      background-color: #fff;

      &:nth-child(n+7) {
        margin-top: 16px;
      }

      &:nth-child(6n+1) {
        margin-left: 0;
      }

      &:hover {
        img {
          width: 110%;
          height: 110%;
          margin-top: -2%;
          margin-left: -5%;
        }
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;
      }
    }
  }
}

@media (max-width: 767.9px) {
  .page-about-cloud-community {
    .contributors {
      li {
        width: calc((100% - 16px) / 2);
        margin-left: 16px;

        &:nth-child(n+7) {
          margin-top: 0;
        }

        &:nth-child(6n+1) {
          margin-left: 16px;
        }

        &:nth-child(2n+1) {
          margin-left: 0;
        }

        &:nth-child(n+3) {
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
